"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var makeActivityTracker = function ($http, apiBaseUrl) {
    var THROTTLING = 3600000;
    var notifyOfActivity = function () {
        $http.post("".concat(apiBaseUrl, "/users/activity"));
    };
    var throttledNotifier = lodash_1.default.throttle(notifyOfActivity, THROTTLING, { leading: true, trailing: false });
    return throttledNotifier;
};
exports.default = makeActivityTracker;
